import { toastStore } from "./toastStore";

export const notifySuccess = (title: string): void => {
  toastStore.push("success", title);
};

export const notifyError = (title: string): void => {
  toastStore.push("error", title);
};
